import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardpopupComponent } from './dashboardpopup.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
      path: '',
      component: DashboardpopupComponent,
      data: {
          title: 'DashBoard'
      }
  }
];
@NgModule({
  declarations: [DashboardpopupComponent],
  imports: [
    BrowserModule,    
    CommonModule,    
    RouterModule.forChild(routes)
  ]
})
export class DashboardpopupModule { }

